import { Card } from "react-bootstrap";
import { GrResources } from "react-icons/gr";
import { useParams } from "react-router-dom";
import { projectPrimaryColor } from "../../generalConfigs";

type TextDetails = {
    title: string;
    subtitle: string;
}
export default function UnavailableResource() {
    const { resource } = useParams<{ resource: 'asset' }>();
    const { title, subtitle } = getTextDetails(resource);


    return <>
        <div className="az-content pd-t-20 pd-b-20">
            <Card className="rounded-button pd-20">
                <div className="centered-flex">
                    <GrResources size={100} color={projectPrimaryColor} />
                </div>
                <h1 className="tx-34 text-center">Recurso indisponível</h1>
                <h2 className="text-center tx-light">{title}</h2>
                <p className="text-center tx-light">
                    {subtitle}
                </p>
            </Card>
        </div>
    </>

}


const genericTextDetails: TextDetails = {
    title: 'Desculpe, o recurso que você tentou acessar está temporariamente indisponível.',
    subtitle: ''
}

function getTextDetails(resource: string): TextDetails {
    const availableDetails: Record<string, TextDetails> = {
        "asset": {
            title: "Desculpe, o ativo que você tentou visualizar está temporariamente indisponível.",
            subtitle: "Você pode escolher outros ativos para analisar, em caso de dúvidas, entre em contato conosco."
        }
    }
    const selectedDetails = availableDetails[resource];

    if (!selectedDetails) {
        return genericTextDetails
    }

    return selectedDetails;
}

